module.exports = __webpack_public_path__ + "static/media/2_screen.3e0a46d5.png";